var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuRent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10537 0L3.41123 7.34366H4.89557L6.3796 0.917958H6.7679L5.71735 7.34366H6.861L7.37608 4.18181H11.3466V7.34366H12.5566V4.18181H16.7175L17.2326 7.34366H18.2832L17.2326 0.917958H17.6285L19.1125 7.34366H20.5883L18.8951 0H5.10537ZM7.93117 0.917958H16.1629L16.5069 3H7.5L7.93117 0.917958ZM2.74866 8L2.66769 9.79155H21.3328L21.4138 8H2.74866ZM2.63505 10.7095L0 22.133H24L21.3634 10.7095H19.9104L22.3082 21H20.5229L18.8339 10.7095H17.3379L18.0621 15.1463H12.5566V10.7095H11.3466V15.1463H5.83789L6.56206 10.7095H5.16657L3.42083 21H1.62148L4 10.7095H2.63505ZM5.83789 16.5H18.4728L19.2134 21H4.89557L5.83789 16.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRent);
export default __webpack_public_path__ + "static/media/menuRent.b7b92588d0c8ca54e14122f3be4ec812.svg";
export { ForwardRef as ReactComponent };